import React, { useState } from "react";
import SurvayParent from "../../Components/parent/SurvayParent";
import FeedBack from "../../Components/parent/FeedBack";

const ParentSurvey = () => {
  const [tab, setTab] = useState("survey");
  
  

  return (
    <div className="d-flex flex-column gap-4 mt-3">
      <div className="d-flex align-items-center gap-3">
        <button className={`text-capitalize btn btn-sm py-2 px-3 ${tab === "survey" ? "btn-primary" : "btn-secondary stylesUnSelcBtn"}`} onClick={() => setTab("survey")}>Survey</button>
        <button className={`text-capitalize btn btn-sm py-2 px-3 ${tab === "feedback" ? "btn-primary" : "btn-secondary stylesUnSelcBtn"}`} onClick={() => setTab("feedback")}>Feedback</button>

      </div>
      {tab === "feedback" && 
        <FeedBack />
      }

      {tab === "survey" && 
      <SurvayParent />
      }
    </div>
  );
};

export default ParentSurvey;
